<template>
	<v-card :elevation="1" class="flex round-card background-2">
        <v-card-title class="pa-3" style="white-space: nowrap">
			<p class="pl-2 pl-xl-3">Preventivi</p>
            <v-spacer></v-spacer>
            <v-select
                v-show="expand"
                v-model="filters['year']"
                :items="fieldsset.years"
                label="Anno"
                solo flat
                background-color="background-2"
                hide-details
                style="max-width: 100px"
                dense>
            </v-select>
            <v-tooltip top>
			    <template v-slot:activator="{ on }">
                    <v-btn v-on="on" @click="expand = !expand" :loading="loading" icon>
                        <v-icon>{{ expand ? 'expand_less' : 'expand_more' }}</v-icon>
                    </v-btn>
			    </template>
                <span>{{ expand ? 'Contrai' : 'Espandi' }}</span>
            </v-tooltip>
        </v-card-title>            
        <v-divider v-if="expand"></v-divider>

        <v-expand-transition>
                <div v-show="expand" :style="{'height': setHeight}">
                    <v-card-text v-if="thereAreQuotations" class="pt-2 pb-2">
                        <template v-for="(quotation, key, index) in quotations">
                            <div :key="index" class="py-2">
                                <h3 class="fs12i fw500">{{quotationStatusTrans(quotation.status)}}<span class="grey--text"> ({{ quotation.status_count }})</span></h3>
                                <v-progress-linear :value="(100 * quotation.status_count) / quotationsSum" height="5" :color="quotationStatusColor(quotation.status)"></v-progress-linear>
                                <span class="caption" style="float: right">{{((100 * quotation.status_count) / quotationsSum).toFixed(2)}} % </span>
                            </div>
                        </template>
                    </v-card-text>
                    <v-card-text v-else class="pt-2 pb-0">
                        <v-card class="fs12i pt-3 mx-3 background-2" elevation="0">
                            <v-card-text class="text-center pb-1">Non è stata ancora creato alcuna preventivo</v-card-text>
                            <v-card-text class="text-center pt-1">
                            <v-btn text small ripple @click="$eventBusUtility.goTo($router, 'quotations-create')"  color="indigo" class="fs11i" style="margin:auto">crea preventivo</v-btn>
                            </v-card-text>
                        </v-card>
                    </v-card-text>
                    <v-card-text v-if="thereAreQuotations && expand" class="body-2 pt-2 pb-2 pr-4 text-center" style="position: absolute; bottom: 0;">
                        <div style="display: inline-flex; flex-direction: column;" class="green--text text--accent-3">
                            <span style="font-size: 12px" class="green--text text--accent-3">Totale</span> 
                            <span style="font-weight: 500; font-size: 22px">{{ quotationsSum }}</span>
                        </div>
                    </v-card-text>
                </div>
        </v-expand-transition>

    </v-card>

</template>

<script>

    export default {
        name: 'quotations-status',
        props: {

        },

        data() {
            return {
                quotations: [],
                quotationsSum: 0,
                expand: JSON.parse(localStorage.getItem('my_quotations_status_'+this.$store.getters.getProfile.id)),
                loading: false,
                fieldsset: {},
                filters: {},                
            }
        },

        computed: {
            thereAreQuotations() {
                if(this.quotationsSum > 0) {
                    return true
                } else return false
            },

            setHeight() {
                if(this.$store.getters.checkModelPermissions('opportunity')) {
                    return '450px'
                } else return 'auto'
            }
        },

        watch: {

            'filters.year' (newVal) {
                this.initialize()
            },
            
            expand: {
                handler(newValue, oldValue) {
                    if(newValue == true) {
                        this.getData()
                    } else {
                        localStorage.setItem('my_quotations_status_'+this.$store.getters.getProfile.id, JSON.stringify(false))
                    }
                },
                immediate: true
            }
        },
    

        methods: {

            getData() {
                this.getInfo().then(() => {
                    let first = _.first(this.fieldsset.years)
                    if(first) {
                        this.$set(this.filters, 'year', first.value)
                    }
                })
            },

            getInfo() {
                return new Promise((resolve, reject) => {
                    this.axios.get('myquotations-info').then(response => {
                        // get body data
                        this.fieldsset = response.data.info

                        this.$store.commit('endProgress')
                        this.loaded = true
                        resolve()
                    }, response => {
                        // error callback
                        reject()
                    })
                })
            },

            initialize() {
                this.loading = true
                this.axios.post('myquotations', this.filters).then(response => {
                    this.quotationsSum = 0
                    this.quotations = response.data.data

                    _.forEach(this.quotations, (value, key) => {
                        this.quotationsSum += value.status_count;
                    })
                    
                    localStorage.setItem('my_quotations_status_'+this.$store.getters.getProfile.id, JSON.stringify(true))
                    this.loading = false
                }, response => {
                        // error callback
                })                
            },

            quotationStatusTrans(status) {
                switch (status) {
                    case 'approved':
                    return 'Accettato'
                    case 'bill':
                    return 'Da Fatturare'
                    case 'billed':
                    return 'Fatturato'                    
                    case 'partly_billed':
                    return 'Parzialmente Fatturato'
                    case 'new':
                    return 'Nuovo'                    
                    case 'quotation_sent':
                    return 'Preventivo Inviato'                    
                    case 'refused':
                    return 'Rifiutato'
                    case 'suspended':
                    return 'Sospeso'
                }
            },         

            quotationStatusColor(status) {
                switch (status) {
                    case 'approved':
                    return 'success'
                    case 'bill':
                    return 'info'
                    case 'billed':
                    return 'deep-purple lighten-2'
                    case 'partly_billed':
                    return 'light-blue accent-1'
                    case 'new':
                    return 'red accent-3'                    
                    case 'quotation_sent':
                    return 'primary'                    
                    case 'refused':
                    return 'grey lighten-1'
                }
            }
        },
    }
</script>
<style>
.v-toolbar__content {
    padding-left: 8px !important;
}

</style>